import { render, staticRenderFns } from "./CollectionItemThumb.vue?vue&type=template&id=075c42bb&lang=pug&"
import script from "./CollectionItemThumb.vue?vue&type=script&lang=js&"
export * from "./CollectionItemThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports